export default __webpack_public_path__ + "img/db58c778eba594ac5307a0c8426b9e70.png";